AquaTechTheme.COUNTRY_TO_STORE = {
    'AX': { label: 'Åland Islands', suggest: 'US' },
    'AL': { label: 'Albania', suggest: 'US' },
    'AD': { label: 'Andorra', suggest: 'US' },
    'AI': { label: 'Anguilla', suggest: 'US' },
    'AG': { label: 'Antigua and Barbuda', suggest: 'US' },
    'AR': { label: 'Argentina', suggest: 'US' },
    'AM': { label: 'Armenia', suggest: 'US' },
    'AW': { label: 'Aruba', suggest: 'US' },
    'AU': { label: 'Australia', suggest: 'AU' },
    'AT': { label: 'Austria', suggest: 'US' },
    'AZ': { label: 'Azerbaijan', suggest: 'US' },
    'BS': { label: 'Bahamas', suggest: 'US' },
    'BD': { label: 'Bangladesh', suggest: 'US' },
    'BB': { label: 'Barbados', suggest: 'US' },
    'BY': { label: 'Belarus', suggest: 'US' },
    'BE': { label: 'Belgium', suggest: 'US' },
    'BZ': { label: 'Belize', suggest: 'US' },
    'BM': { label: 'Bermuda', suggest: 'US' },
    'BO': { label: 'Bolivia', suggest: 'US' },
    'BA': { label: 'Bosnia and Herzegovina', suggest: 'US' },
    'BV': { label: 'Bouvet Island', suggest: 'US' },
    'IO': { label: 'British Indian Ocean Territory', suggest: 'US' },
    'BR': { label: 'Brazil', suggest: 'US' },
    'BN': { label: 'Brunei', suggest: 'US' },
    'BG': { label: 'Bulgaria', suggest: 'US' },
    'KH': { label: 'Cambodia', suggest: 'US' },
    'CA': { label: 'Canada', suggest: 'US' },
    'KY': { label: 'Cayman Islands', suggest: 'US' },
    'CL': { label: 'Chile', suggest: 'US' },
    'CN': { label: 'China', suggest: 'US' },
    'CX': { label: 'Christmas Island', suggest: 'US' },
    'CC': { label: 'Cocos (Keeling) Islands', suggest: 'US' },
    'CO': { label: 'Colombia', suggest: 'US' },
    'CK': { label: 'Cook Islands', suggest: 'US' },
    'CR': { label: 'Costa Rica', suggest: 'US' },
    'HR': { label: 'Croatia', suggest: 'US' },
    'CU': { label: 'Cuba', suggest: 'US' },
    'CW': { label: 'Curaçao', suggest: 'US' },
    'CY': { label: 'Cyprus', suggest: 'US' },
    'CZ': { label: 'Czechia', suggest: 'US' },
    'DK': { label: 'Denmark', suggest: 'US' },
    'DM': { label: 'Dominica', suggest: 'US' },
    'DO': { label: 'Dominican Republic', suggest: 'US' },
    'EC': { label: 'Ecuador', suggest: 'US' },
    'EG': { label: 'Egypt', suggest: 'US' },
    'SV': { label: 'El Salvador', suggest: 'US' },
    'EE': { label: 'Estonia', suggest: 'US' },
    'FK': { label: 'Falkland Islands', suggest: 'US' },
    'FO': { label: 'Faroe Islands', suggest: 'US' },
    'FJ': { label: 'Fiji', suggest: 'US' },
    'FI': { label: 'Finland', suggest: 'US' },
    'FR': { label: 'France', suggest: 'US' },
    'GF': { label: 'French Guiana', suggest: 'US' },
    'PF': { label: 'French Polynesia', suggest: 'US' },
    'GE': { label: 'Georgia', suggest: 'US' },
    'DE': { label: 'Germany', suggest: 'US' },
    'GI': { label: 'Gibraltar', suggest: 'US' },
    'GR': { label: 'Greece', suggest: 'US' },
    'GL': { label: 'Greenland', suggest: 'US' },
    'GD': { label: 'Grenada', suggest: 'US' },
    'GP': { label: 'Guadeloupe', suggest: 'US' },
    'GT': { label: 'Guatemala', suggest: 'US' },
    'GG': { label: 'Guernsey', suggest: 'US' },
    'GY': { label: 'Guyana', suggest: 'US' },
    'HT': { label: 'Haiti', suggest: 'US' },
    'HN': { label: 'Honduras', suggest: 'US' },
    'HK': { label: 'Hong Kong SAR', suggest: 'US' },
    'HU': { label: 'Hungary', suggest: 'US' },
    'IS': { label: 'Iceland', suggest: 'US' },
    'IN': { label: 'India', suggest: 'US' },
    'IQ': { label: 'Iraq', suggest: 'US' },
    'IE': { label: 'Ireland', suggest: 'US' },
    'IM': { label: 'Isle of Man', suggest: 'US' },
    'IL': { label: 'Israel', suggest: 'US' },
    'IT': { label: 'Italy', suggest: 'US' },
    'JM': { label: 'Jamaica', suggest: 'US' },
    'JP': { label: 'Japan', suggest: 'US' },
    'JE': { label: 'Jersey', suggest: 'US' },
    'JO': { label: 'Jordan', suggest: 'US' },
    'KE': { label: 'Kenya', suggest: 'US' },
    'KI': { label: 'Kiribati', suggest: 'US' },
    'KP': { label: 'North Korea', suggest: 'US' },
    'KR': { label: 'South Korea', suggest: 'US' },
    'KW': { label: 'Kuwait', suggest: 'US' },
    'XK': { label: 'Kosovo', suggest: 'US' },
    'LV': { label: 'Latvia', suggest: 'US' },
    'LB': { label: 'Lebanon', suggest: 'US' },
    'LI': { label: 'Liechtenstein', suggest: 'US' },
    'LT': { label: 'Lithuania', suggest: 'US' },
    'LU': { label: 'Luxembourg', suggest: 'US' },
    'MG': { label: 'Madagascar', suggest: 'US' },
    'MY': { label: 'Malaysia', suggest: 'US' },
    'MV': { label: 'Maldives', suggest: 'US' },
    'MT': { label: 'Malta', suggest: 'US' },
    'MQ': { label: 'Martinique', suggest: 'US' },
    'MR': { label: 'Mauritania', suggest: 'US' },
    'MU': { label: 'Mauritius', suggest: 'US' },
    'YT': { label: 'Mayotte', suggest: 'US' },
    'MX': { label: 'Mexico', suggest: 'US' },
    'MD': { label: 'Moldova, Republic of', suggest: 'US' },
    'MC': { label: 'Monaco', suggest: 'US' },
    'MN': { label: 'Mongolia', suggest: 'US' },
    'ME': { label: 'Montenegro', suggest: 'US' },
    'MS': { label: 'Montserrat', suggest: 'US' },
    'MA': { label: 'Morocco', suggest: 'US' },
    'MZ': { label: 'Mozambique', suggest: 'US' },
    'MM': { label: 'Myanmar', suggest: 'US' },
    'NR': { label: 'Nauru', suggest: 'US' },
    'NP': { label: 'Nepal', suggest: 'US' },
    'NL': { label: 'Netherlands', suggest: 'US' },
    'AN': { label: 'Netherlands Antilles', suggest: 'US' },
    'NC': { label: 'New Caledonia', suggest: 'US' },
    'NZ': { label: 'New Zealand', suggest: 'AU' },
    'NI': { label: 'Nicaragua', suggest: 'US' },
    'NU': { label: 'Niue', suggest: 'US' },
    'MK': { label: 'North Macedonia', suggest: 'US' },
    'NO': { label: 'Norway', suggest: 'US' },
    'PK': { label: 'Pakistan', suggest: 'US' },
    'PA': { label: 'Panama', suggest: 'US' },
    'PG': { label: 'Papua New Guinea', suggest: 'US' },
    'PY': { label: 'Paraguay', suggest: 'US' },
    'PE': { label: 'Peru', suggest: 'US' },
    'PH': { label: 'Philippines', suggest: 'US' },
    'PN': { label: 'Pitcairn Islands', suggest: 'US' },
    'PL': { label: 'Poland', suggest: 'US' },
    'PT': { label: 'Portugal', suggest: 'US' },
    'QA': { label: 'Qatar', suggest: 'US' },
    'RE': { label: 'Réunion', suggest: 'US' },
    'RO': { label: 'Romania', suggest: 'US' },
    'BL': { label: 'St. Barthélemy', suggest: 'US' },
    'KN': { label: 'St. Kitts and Nevis', suggest: 'US' },
    'LC': { label: 'St. Lucia', suggest: 'US' },
    'MF': { label: 'St. Martin', suggest: 'US' },
    'PM': { label: 'St. Pierre & Miquelon', suggest: 'US' },
    'VC': { label: 'St. Vincent & Grenadines', suggest: 'US' },
    'WS': { label: 'Samoa', suggest: 'US' },
    'SM': { label: 'San Marino', suggest: 'US' },
    'RS': { label: 'Serbia', suggest: 'US' },
    'SC': { label: 'Seychelles', suggest: 'US' },
    'SG': { label: 'Singapore', suggest: 'US' },
    'SX': { label: 'Sint Maarten', suggest: 'US' },
    'SK': { label: 'Slovakia', suggest: 'US' },
    'SI': { label: 'Slovenia', suggest: 'US' },
    'SB': { label: 'Solomon Islands', suggest: 'US' },
    'ZA': { label: 'South Africa', suggest: 'US' },
    'ES': { label: 'Spain', suggest: 'US' },
    'LK': { label: 'Sri Lanka', suggest: 'US' },
    'SR': { label: 'Suriname', suggest: 'US' },
    'SJ': { label: 'Svalbard and Jan Mayen', suggest: 'US' },
    'SE': { label: 'Sweden', suggest: 'US' },
    'CH': { label: 'Switzerland', suggest: 'US' },
    'TW': { label: 'Taiwan', suggest: 'US' },
    'TH': { label: 'Thailand', suggest: 'US' },
    'TL': { label: 'Timor-Leste', suggest: 'US' },
    'TK': { label: 'Tokelau', suggest: 'US' },
    'TO': { label: 'Tonga', suggest: 'US' },
    'TT': { label: 'Trinidad and Tobago', suggest: 'US' },
    'TR': { label: 'Turkey', suggest: 'US' },
    'TC': { label: 'Turks and Caicos Islands', suggest: 'US' },
    'TV': { label: 'Tuvalu', suggest: 'US' },
    'UA': { label: 'Ukraine', suggest: 'US' },
    'AE': { label: 'United Arab Emirates', suggest: 'US' },
    'GB': { label: 'United Kingdom', suggest: 'US' },
    'US': { label: 'United States of America', suggest: 'US' },
    'UM': { label: 'United States Outlying Islands', suggest: 'US' },
    'UY': { label: 'Uruguay', suggest: 'US' },
    'VA': { label: 'Vatican City', suggest: 'US' },
    'VU': { label: 'Vanuatu', suggest: 'US' },
    'VE': { label: 'Venezuela', suggest: 'US' },
    'VG': { label: 'British Virgin Islands', suggest: 'US' },
    'WF': { label: 'Wallis and Futuna', suggest: 'US' },
    'ZW': { label: 'Zimbabwe', suggest: 'US' }
};
